import { Sequence } from '@forchange/storytime';
import { MutationTree } from 'vuex';
import {
  CallStatus,
  IState,
  Note,
  PracticeCourt,
  Score,
  SurverData,
  SingulSurveyRecord,
  PortalMessage,
  UserInfo,
  Festival,
  AuthStatus,
  IGlobalConfig
} from '../types';

const mutations: MutationTree<IState> = {
  setResources(state, { context, project }: IState) {
    state.context = context;
    state.project = project;
  },
  setEnvironment(state, { environment }: IState) {
    state.environment = environment;
  },
  setCourseName(state, courseName: string) {
    state.courseName = courseName;
  },
  setVersion(state, version: string) {
    state.version = version;
  },
  setCourseCover(state, courseCover: string) {
    state.courseCover = courseCover;
  },
  setCourseDescription(state, courseDescription: string) {
    state.courseDescription = courseDescription;
  },
  setAuthingId(state, authingId: string) {
    state.authingId = authingId;
  },
  setMenuActive(state, { menuActive }: IState) {
    state.menuActive = menuActive;
  },
  setPortal(state, portal: Sequence) {
    state.portalSequence?.push(portal);
  },
  popPortal(state) {
    state.portalSequence.pop();
  },
  setPortalMessage(state, portalMessage: PortalMessage) {
    state.portalMessage = {
      ...state.portalMessage,
      ...portalMessage
    };
  },
  setScore(state, score: Score) {
    state.score = {
      ...state.score,
      ...score
    };
  },
  setIsLocalHistory(state, isLocalHistory) {
    state.isLocalHistory = isLocalHistory;
  },
  setCallStatus(state, callStatus: CallStatus) {
    state.callStatus = {
      ...state,
      ...callStatus
    };
  },
  setLoading(state, loading: boolean) {
    state.loading = loading;
  },
  setSurvey(state, survey: SurverData) {
    state.survey = {
      ...state.survey,
      ...survey
    };
  },
  setPracticeCourtVisible(state, visible: boolean) {
    state.practiceCourt.visible = visible;
  },
  setPracticeCourt(state, practiceCourt: PracticeCourt) {
    state.practiceCourt = {
      ...state.practiceCourt,
      ...practiceCourt
    };
  },

  setCurrentNoteCheck(state, note: Note) {
    state.note = {
      currentCheckId: note.currentCheckId,
      currentCheckIndex: note.currentCheckIndex
    };
  },

  setSurveyRecord(state, singulSurveyRecord: SingulSurveyRecord) {
    const smoeSurveyRecord = state.surveyRecord.some(
      (item) => item.contentId === singulSurveyRecord.contentId
    );
    if (smoeSurveyRecord) {
      state.surveyRecord.map((item) => {
        if (item.contentId === singulSurveyRecord.contentId) {
          item.content = singulSurveyRecord.content;
          item.submit = singulSurveyRecord.submit;
        }
        return item;
      });
    } else {
      state.surveyRecord.push(singulSurveyRecord);
    }
  },

  setUserInfo(state, userInfo: UserInfo) {
    state.userInfo = {
      ...state.userInfo,
      ...userInfo
    };
  },

  setFestival(state, festival: Festival) {
    state.isFestival = festival;
  },

  setDisalbeCopy(state, disalbeCopy: boolean) {
    state.disalbeCopy = disalbeCopy;
  },
  setWatermark(state, watermark: boolean) {
    state.watermark = watermark;
  },
  setSetyleNavHeight(state, setyleNavHeight: number) {
    state.setyleNavHeight = setyleNavHeight;
    window.clewordNav = state;
  },
  setClewordNavVisible(state, clewordNavVisible: boolean) {
    state.clewordNavVisible = clewordNavVisible;
    window.clewordNav = state;
  },
  setIsLookBack(state, isLookBack: boolean) {
    state.isLookBack = isLookBack;
  },

  setIsPublic(state, isPublic: number) {
    state.isPublic = isPublic;
  },

  setAuth(state, payload: { key: string; status: AuthStatus }) {
    if (payload.key in state.auth) {
      state.auth[payload.key].status = payload.status;
    }
  },

  setBind(state, payload: { key: string; status: AuthStatus }) {
    if (payload.key in state.bind) {
      state.bind[payload.key].status = payload.status;
    }
  },
  setGlobalConfig(state, globalConfig: IGlobalConfig) {
    state.globalConfig = globalConfig;
  },
  setCameraOn(state, isOn: boolean) {
    state.isCameraOn = isOn;
  }
};

export default mutations;
